import React, { FC } from 'react';

import { EDataTestId } from '@webtrader/core/constants/test';
import { getDialCodeFromCountryKey } from '@webtrader/core/format/country';
import { useTranslation } from '@webtrader/core/i18n';
import { useTheme } from '@webtrader/core/services/theme/v2';

import ValidationError from '@/components/FormValidationError';
import AntDesign from '@/components/Icons/AntDesign';
import TextInput from '@/components/TextInput';
import { checkIsAndroid } from '@/utils/device';

import CountryDialCodeDropdown from '../../../../components/CountryDialCodeDropdown';
import { StyledFormField, StyledFormTitle, StyledFormTitleContainer, StyledInputWrapper } from '../styled';

interface IProps {
  countryKey: string | undefined;
  value: string | undefined;
  showValidation: boolean;
  onChange: ((value: string | number | undefined) => void) | undefined;
  onDialCodeChange: ((value: string | number | undefined) => void) | undefined;
}

const PhoneNumberTextField: FC<IProps> = (props) => {
  const { countryKey, value, showValidation, onChange, onDialCodeChange } = props;
  const { theme } = useTheme();
  const { t } = useTranslation();

  return (
    <>
      <StyledFormField>
        <StyledFormTitleContainer>
          <AntDesign name="earth" size={24} color={theme.colors.text[1]} />
          <StyledFormTitle>{t('Dial Code')}</StyledFormTitle>
        </StyledFormTitleContainer>
        <StyledInputWrapper>
          <CountryDialCodeDropdown value={getDialCodeFromCountryKey(countryKey)} onChange={onDialCodeChange} />
          {!countryKey && <ValidationError showValidation={showValidation} message={t('Dial code is required')} />}
        </StyledInputWrapper>
      </StyledFormField>
      <StyledFormField>
        <StyledFormTitleContainer>
          <AntDesign name="phone" size={24} color={theme.colors.text[1]} />
          <StyledFormTitle>{t('Phone Number')}</StyledFormTitle>
        </StyledFormTitleContainer>
        <StyledInputWrapper>
          <TextInput
            onlyNumeric={true}
            contextMenuHidden={true}
            multiline={checkIsAndroid()}
            numberOfLines={1}
            borderless={false}
            keyboardType={'number-pad'}
            value={value}
            onChangeText={onChange}
            testID={EDataTestId.DEMO_ACCOUNT_CREATION_MODAL_PHONE}
          />
          <ValidationError
            showValidation={showValidation}
            message={value ? t('Phone number is invalid') : t('Phone number is required')}
          />
        </StyledInputWrapper>
      </StyledFormField>
    </>
  );
};

export default PhoneNumberTextField;
